import type { Label } from '../types'

function isNewLabel(label: Label) {
    return label.sys.id === '5bLamf6l3rBgNYIaEyBfeF'
}

export { isNewLabel }
